<template>
  <div id="ScannedProfile">

  <div class="all-owned-pets">
    <div v-if="loading" class="loading-spinner">
      <SkeletonPetCards />
    </div>

    <div  v-else-if="!loading && newScan">
      <p>Welcome to HeyBuddy!</p>
      <br />
      <p>Please activate this device to your account</p>
      <button class="new-tag-btn" @click="gotoLogin()">Activate Device</button>

      <br/>
      <div class="help-section">
        <p>If you need assistance please check out the links below</p>
        <br/>
        <ul>
          <li><a href="#">FAQ</a></li>
          <li><a href="#">How to Set Up</a></li>
          <li><a href="#">Contact</a></li>
        </ul>
      </div>
    </div>
    <div class="active-account-page" v-else-if="!newScan && hasPets" >
      <div class="active-owner-header">
        <h2>{{ownerdata.username}}'s Pets</h2>
      </div>
      <div>

      <XyzTransitionGroup xyz="fade up big" v-if="pets.length > 0 && !loading">
        <div @click="gotoScannedPage(pet._id)"
        v-for="(pet, idx) in pets" :key="idx"
        class="pet-card-wrapper">
          <PetCard :pet_id="pet._id" :userdata="ownerdata" :editablePage="false" />
        </div>
      </XyzTransitionGroup>

    </div>
  </div>
    <div class="active-account-page" v-else-if="!hasPets" >
      <div class="active-owner-header">
        <h2>{{ownerdata.username}}'s Pets</h2>
      </div>
      <p class="no-pets">This User Does Not Have Any Pets</p>
      <!-- <IntakeLedger :width="90" />
      <ConfirmModal :pet="pet" @hideModal="toggleModal" v-if="showConfirmModal" /> -->
    </div>
  </div>
</div>
</template>

<script>
//When
import {db} from '@/_firebase/init'
import {mapState} from 'vuex'
import axios from 'axios'
// import ScannedBanner from '@/petprofile/components/scanned/ScannedBanner.vue'
import SkeletonPetCards from '@/petprofile/components/main/SkeletonPetCards.vue'
import PetCard from '@/petprofile/components/pet/PetCard.vue'

export default {
  name: 'ScannedProfile',
  components: {
    PetCard,
    SkeletonPetCards
  },
  data(){
    return{
      showConfirmModal: false,
      pets_owned: [],
      ownerdata: {
        id: '',
        username:'',
        phone:'',
        address: '',
      },
      pets:[{photo:'', name: ''}],
      loading: true,
      other_name: this.$route.params.username,
      newScan: false,
      hasPets: true,
    }
  },
  watch:{
    // pets_owned(nv,ov){
    //   console.log(nv, ov)
    //   for(let pid of nv){
    //     this.getPetData(pid)
    //   }
    // }
  },
  methods:{
    doThis(smth){
      console.log(smth);
    },
    toggleModal(val){
      this.showConfirmModal = val
    },
    // readQRCode(evt){
    //       let file = evt.target.files[0];
    //       console.log(file)
    //     },
    gotoRoute(rotue){
      this.$router.push({name: rotue})
    },
    gotoLogin(){
      // this.$router.push({name: 'ActivateByLogin', query:{tag: this.queryID}})
      localStorage.setItem('other_name', this.other_name)
    },
    // async getDeviceData(){
    //   const deviceRef = db.collection('user').doc(this.queryID);
    //   const doc = await deviceRef.get();
    //   if (!doc.exists) {
    //     console.log('No such document!');
    //   } else {
    //     if(doc.data().activated){
    //       this.newScan = false
    //       this.ownerdata.id = doc.data().owner._id
    //       this.getUserData(this.ownerdata.id)
    //     }else{
    //       this.loading = false
    //       this.newScan = true
    //     }
    //   }
    // },
    async getUserData(){
      this.loading = true
      const userRef = db.collection('users')
      const doc = await userRef.where('username', '==', this.other_name).get();
      if (doc.empty) {
        console.log('No matching documents.');
        return;
      }
      doc.forEach(doc => {
       this.ownerdata.id = doc.id
       this.ownerdata.fname = doc.data().fname
       this.ownerdata.lname = doc.data().lname
        this.ownerdata.username = doc.data().username
        this.ownerdata.phone = doc.data().phone
        this.ownerdata.address = doc.data().address
        const pet_list = doc.data().pets_owned
        // console.log(pet_list)
        this.loading = false
        this.newScan = false
        if(pet_list.length == 0){
          this.pets = []
          this.hasPets = false
        }else{
          for(let pet_id of pet_list){
            this.pets_owned.push(pet_id)
            this.getPetData(pet_id)
          }
        }
      });
    },
    async getPetData(pet_id){
      this.pets = []
      const config = {
        headers:{
        'petID':this.pet_id,
        'username':this.ownerdata.username
        }
      }
      // const petRef = db.collection('pets').doc(pet_id);
      const pet_doc = await axios.get(`https://barkbadge.pythonanywhere.com/pets/get_pet/guest`,config);
      // console.log(pet_doc.data())
      console.log("pet_doc",pet_doc);
      let pet_data = {
        _id: pet_id,
        photo: pet_doc.data().photo,
        banner: pet_doc.data().banner,
        name: pet_doc.data().name,
        pet_type: pet_doc.data().pet_type,
        owner: pet_doc.data().owner,
        allergies: pet_doc.data().allergies,
      }
      this.pets.push(pet_data)
      return pet_doc.data()
    },
    gotoScannedPage(pet_id){
      this.$store.commit('SET_OWNER_ID', this.ownerdata.id)
      setTimeout(() =>{

        this.$router.push({name: 'ScannedPage', params:{ id: this.other_name, pet_id: pet_id}})

      }, 200);
    }
  },
  computed:{
    ...mapState(['userID']),
  },
  created(){
    this.$store.commit('REMOVE_OWNER_ID')
    // localStorage.removeItem('other_name')
    this.getUserData()
  },
}
</script>
<style scoped>
#ScannedProfile{
  margin: auto;
  padding: 0;
  padding-bottom: 5rem;
  padding-top: 5rem;
  margin-top: -2rem;
  max-width: 900px;
  min-height: 90vh;
  background-color:#f4f6fa;
}
.new-tag-btn{
  background-color: var(--primary);
  text-align:center;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  padding: .5rem 1rem;
  color: #fff;
  width: 60%;
  margin: 2rem auto;
  cursor: pointer;
  transition: 1s;
}
.all-owned-pets{
  width: 90%;
  margin: auto;
  text-align:center;
}
.add-a-pet{
  text-align:center;
  height: 2rem;
  width: 60%;
  border: 2px solid #888;
  border-radius: 35px;
  margin: 2rem auto;
  color: var(--primary);
  position: relative;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  transition: 1s;
}
.add-a-pet:hover{
  transform: translateY(-10px);
  cursor: pointer;
}
.active-owner-header{
  width: 100%;
  margin: auto;
  color: #fff;
  background-color: #26385F;
  padding: .5rem 0;
  border-radius: 10px 10px 0 0;
  transition:1s;
}
.pet-card-wrapper{
  cursor:pointer;
}
/*----------------------*\
|     PROFILE IMAGE
\*----------------------*/
.help-section{
  text-align: left;
  margin: auto;
  width: 80%;
}

/*mobile base */
.scanning-for-code{
  display: block;
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
.close-scanner{
    z-index: 11;
  position: absolute;
  top: 2rem;
  right: 2rem;
  color: #fff;
  padding: .4rem 1.2rem;
  font-size: 3rem;
  border-radius: 100%;
  background-color: transparent;
  border: 3px solid #fff;;
}
.no-pets{
  font-size: 1.4rem;
  margin: 4rem auto;
}
@media only screen and (max-width: 600px) {

}
</style>
